import React from 'react';
import {Button} from './styles/SubmitDecisionComponen-style';
import {useNavigate} from 'react-router-dom';
import Cookies from "universal-cookie";
const cookies = new Cookies();



function SubmitDecisionComponent(props){

    const navigate = useNavigate();
 
    
    const SubmitDecision = async(e) => {
        e.preventDefault();
        const meetingNameDict = {meetingName: props.meetingName};
        const opiniondict = {opiniondict: props.opiniondict};
        const decisionDict = {decisionDict: props.DecisionDict};
        const Agenda = {agenda: props.agenda};
        const mergeObj = {...meetingNameDict, ...Agenda, ...opiniondict, ...decisionDict};
        console.log(mergeObj);

        const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        
        try{
            const token = cookies.get("token");
            const response = await fetch(REACT_APP_BACKEND_URL+'/saveDecision', {
                method: 'POST',
                headers : {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(mergeObj)
            });

            if (response.ok) {
                console.log('Data Sent Successfully');
                navigate(`/`);
            } else {
                console.error('Failed to send data');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
            <Button type='Submit' onClick={SubmitDecision}>Submit</Button>
    );
} 
export default SubmitDecisionComponent;